<template>
  <form>
    <div class="dashboard-block">
      <h2>{{ $starLabel }} Scores</h2>

      <div class="panel panel-grey">
        <div class="panel-body">
              <div class="row row-clear-md-4">
                <div class="col-xs-12 col-md-6 col-lg-4">
                  <div :class="$v.marketability.$invalid ? 'form-group has-error' : 'form-group'">
                  <label class="control-label">Marketability</label>
                  <div>
                    <input
                      name="marketability"
                      type="number"
                      class="form-control"
                      v-model="$v.marketability.$model">

                  </div>
                  <div v-if="$v.marketability.$invalid">
                    <span v-if="$v.marketability.required === false" class="help-block pull-right">Marketability is required</span>
                    <span v-if="$v.marketability.minValue === false" class="help-block pull-right">Marketability must be greater than 0</span>
                    <span v-if="$v.marketability.maxValue === false" class="help-block pull-right">Marketability must be less than 10</span>
                    <span v-if="$v.marketability.decimal === false" class="help-block pull-right">Marketability must be a valid decimal number</span>
                  </div>
                </div>
              </div>
                <div class="col-xs-12 col-md-6 col-lg-4">
                <div :class="$v.profile.$invalid ? 'form-group has-error' : 'form-group'">
                  <label class="control-label">Profile</label>
                  <div>
                    <input
                      name="profile"
                      type="number"
                      class="form-control"
                      v-model="$v.profile.$model">
                  </div>
                </div>
                <div v-if="$v.profile.$invalid">
                  <span v-if="$v.profile.required === false" class="help-block pull-right">Profile is required</span>
                  <span v-if="$v.profile.minValue === false" class="help-block pull-right">Profile must be greater than 0</span>
                  <span v-if="$v.profile.maxValue === false" class="help-block pull-right">Profile must be less than 10</span>
                  <span v-if="$v.profile.decimal === false" class="help-block pull-right">Profile must be a valid decimal number</span>
                </div>
              </div>
                <div class="col-xs-12 col-md-6 col-lg-4">
                <div :class="$v.relationship.$invalid ? 'form-group has-error' : 'form-group'">
                  <label class="control-label">{{ clientName }} Relationship</label>
                  <div>
                    <input
                      name="relationship"
                      type="number"
                      class="form-control"
                      v-model="$v.relationship.$model">
                  </div>
                  <div v-if="$v.relationship.$invalid">
                    <span v-if="$v.relationship.required === false" class="help-block pull-right">Relationship is required</span>
                    <span v-if="$v.relationship.minValue === false" class="help-block pull-right">Relationship must be greater than 0</span>
                    <span v-if="$v.relationship.maxValue === false" class="help-block pull-right">Relationship must be less than 10</span>
                    <span v-if="$v.relationship.decimal === false" class="help-block pull-right">Relationship must be a valid decimal number</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <ladda-button
                  type="submit"
                  class="btn btn-sm btn-primary"
                  :click="handleUpdateScoresCallback">
            Save Changes
          </ladda-button>
        </div>
      </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { notify } from 'utils'
import { required, minValue, maxValue, decimal } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      marketability: null,
      profile: null,
      relationship: null
    }
  },

  validations: {
    marketability: {
      required,
      minValue: minValue(0),
      maxValue: maxValue(10),
      decimal
    },
    profile: {
      required,
      minValue: minValue(0),
      maxValue: maxValue(10),
      decimal
    },
    relationship: {
      required,
      minValue: minValue(0),
      maxValue: maxValue(10),
      decimal
    }
  },

  mounted () {
    this.marketability = this.user.profile.marketability_score
    this.profile = this.user.profile.profile_score
    this.relationship = this.user.profile.pickstar_relationship_score
  },

  computed: mapState('user', ['user']),

  methods: {
    ...mapActions('user', ['updateTalentScores']),

    /**
     * Handle updating talent scores.
     *
     * Validate the data before sending.
     *
     * @return Promise
     */
    handleUpdateScoresCallback () {
      if (this.$v.$invalid) {
        notify.error('Validation failed')
        return Promise.resolve()
      }
      let payload = {
        marketability: this.marketability,
        profile: this.profile,
        relationship: this.relationship
      }
      return this.updateTalentScores({id: this.user.id, payload})
        .then(() => {
          this.$validator.reset()
          notify.success('Successfully updated talent scores.')
        })
        .catch((error) => {
          if (error.response) {
            notify.error('Sorry something has gone wrong, please try again.')
          }
        })
    }
  }
}
</script>
